import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';
import ClientForm from './ClientForm';

/**
 * CreateClientModal
 * Wraps ClientForm in a Modal for inline client creation from other flows
 * (e.g. the Client Quote form). Mirrors ClientFormPage's success timing:
 * the "created successfully" message (rendered by ClientForm) stays visible
 * for 2 seconds before the modal reports success to its parent.
 */
const CreateClientModal = ({ isOpen, onClose, onClientCreated }) => {
  const { t } = useTranslation();

  const handleSuccess = (client) => {
    setTimeout(() => {
      onClientCreated(client);
    }, 2000);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={t('clients.createTitle')}>
      <ClientForm onSuccess={handleSuccess} onCancel={onClose} />
    </Modal>
  );
};

export default CreateClientModal;
